import { RadioGroup } from "radix-ui";
import type { PropsWithChildren } from "react";
import { cn } from "../utils";

/** Props Interface */
interface RadioSelectItemProps extends PropsWithChildren {
	value: string;
	isDisabled?: boolean;
}

export function RadioSelectItem({ value, children, isDisabled }: RadioSelectItemProps) {
	return (
		<RadioGroup.Item
			value={value}
			disabled={isDisabled}
			className={cn(
				"h-stack py-1.5 pl-2 pr-4 border-[0.5px] border-color cursor-pointer focus:input-focused w-max",
				"card-bg",
				"text-sm",
				"rounded-base",
				"data-disabled:opacity-30 data-disabled:cursor-not-allowed",
			)}
		>
			<div className="size-5 p-[4px] rounded-full border-[0.5px] border-color shadow-xs">
				<RadioGroup.Indicator asChild>
					<div
						className={cn(
							"size-full bg-linear-45  rounded-full",
							"from-primary-800 to-primary-600",
							"dark:from-white dark:to-white",
						)}
					/>
				</RadioGroup.Indicator>
			</div>
			{children}
		</RadioGroup.Item>
	);
}
